import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { PROPERTYLAY } from "../lib/data";

export const AssociationBand = () => (
  <section data-testid="association-band" className="bg-[#F5F2EB] border-y border-[#E5DFD3]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28 grid md:grid-cols-12 gap-12 items-center">
      <Reveal className="md:col-span-5">
        <p className="overline text-[#C19A6B] mb-6">In association with</p>
        <div className="bg-[#FDFBF7] border border-[#E5DFD3] p-8 inline-flex items-center justify-center min-w-[220px]">
          <img
            src={PROPERTYLAY.logo}
            alt="Propertylay logo"
            className="max-h-20 w-auto object-contain"
            loading="lazy"
          />
        </div>
      </Reveal>

      <div className="md:col-span-7">
        <Reveal delay={0.1}>
          <h2 className="font-serif-lux text-4xl md:text-5xl text-[#1A1A1A] tracking-tight leading-[1.05]">
            {PROPERTYLAY.name}
          </h2>
          <p className="overline text-[#6E7765] mt-3">Founded by {PROPERTYLAY.founder}</p>
          <p className="font-sans-lux text-[#5C5C5C] mt-6 leading-relaxed max-w-xl">
            {PROPERTYLAY.description}
          </p>
          <div className="flex flex-wrap gap-3 mt-6">
            {PROPERTYLAY.services.map((s) => (
              <span key={s} className="overline text-[#1A1A1A] border border-[#E5DFD3] px-4 py-2">
                {s}
              </span>
            ))}
          </div>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-2 mt-7 font-sans-lux text-sm text-[#5C5C5C]">
            <a href={`tel:${PROPERTYLAY.phoneRaw}`} className="link-sweep text-[#1A1A1A]">{PROPERTYLAY.phone}</a>
            <a href={`mailto:${PROPERTYLAY.email}`} className="link-sweep text-[#1A1A1A]">{PROPERTYLAY.email}</a>
            <span>{PROPERTYLAY.address}</span>
          </div>
          <a
            href={PROPERTYLAY.url}
            target="_blank"
            rel="noreferrer"
            data-testid="propertylay-visit"
            className="inline-flex items-center gap-2 mt-8 overline text-[#1A1A1A] border border-[#1A1A1A] btn-lux hover:text-[#FDFBF7] px-7 py-4"
          >
            Visit Propertylay <ArrowUpRight size={15} />
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
